module.exports = __webpack_public_path__ + "static/img/email.06d68394.png";